module.exports = __webpack_public_path__ + "static/media/Bilat Kneecap Cartoon.de8dcd14.png";